import React,{useEffect,useState} from 'react';
import Logo from '../../components/common/Logo';
import ForgotPasswordForm from '../../components/Auth/ForgotPasswordForm';
import {useNavigate} from 'react-router-dom';
import swal from 'sweetalert';
import {ForgotPassUser} from '../../actions/ForgotpassActions';


function ForgotPassword(){
    const navigate = useNavigate();
    const [loading,setLoading] = useState(false)

    useEffect(() => {
        if(sessionStorage.getItem('userDetail')){
            navigate('/dashboard');
        }
    },[]);
    const onSubmit=(model)=>{
        setLoading(true)
      ForgotPassUser(model).then(res => {
            if (res.status) {
                swal(res.message,'','success');
                setLoading(false)  
            }
            else{
                swal(res.message,'','error');
                setLoading(false)
            }
        })
        .catch(err => {
            console.log(err);
        })
    }
    return(
       <>
       <section className="py-5 login-page">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-6">
                    <div className="text-center">
                    <Logo alt="Logo"/>
                    </div>
                    <div className="login-box">
                        <div className="page-head">
                            <h2>Forgot Password</h2>
                        </div>
                        <ForgotPasswordForm onSubmit={onSubmit} loading={loading}/>
                    </div>
                </div>
            </div>
        </div>
    </section>
       </>
    );
}

export default ForgotPassword;



